import {initWebComponent} from "@/helpers/web-component-helper";
import {addLayer, getLayerByName} from "@/helpers/ol/ol-layer-helper";
import {toggleGeoJsonLayer} from "@/helpers/ol/ol-geo-json-helper";
import {transformExtent} from "ol/proj";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {GeoJSON} from "ol/format";
import {zoomToFeature} from "@/helpers/ol/ol-zoom-helper";
import {getFeatureByIndex} from "@/helpers/main-tab-helper";

export class LayerInfoInfoItemGeometryZoomComponent extends HTMLElement {
    constructor(){
        super();

        const mainTabIndex = this.getAttribute('data-main-tab-index')
        const featureIndex = this.getAttribute('data-feature-index')
        const featureInfoIndex = this.getAttribute('data-feature-info-index')

        const template = document.createElement('template');

        template.innerHTML = `
        <button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header" href="#">
          <span class="fa fa-expand"></span>
          <div class="popper-tooltip" role="tooltip" data-popper-placement="top">
             Zoom naar object
            <div class="arrow" data-popper-arrow=""></div>
          </div>
        </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const feature = getFeatureByIndex(mainTabIndex, featureIndex, featureInfoIndex)
            zoomToFeature(feature)
        })
    }
}

